import { render, staticRenderFns } from "./JourneyPhaseIntro.vue?vue&type=template&id=58c5552e&scoped=true&"
import script from "./JourneyPhaseIntro.vue?vue&type=script&lang=js&"
export * from "./JourneyPhaseIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c5552e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
